import { type Socket, io } from 'socket.io-client';

/**
 * Połączenie WebSocket.
 *
 * Jedno na całą aplikację, bo pokój jest jeden na kartę — drugie połączenie
 * oznaczałoby drugiego uczestnika tego samego pokoju z tej samej przeglądarki,
 * a wtedy kworum końca materiału liczyłoby jedną osobę dwa razy.
 *
 * Uwierzytelnienie idzie ciasteczkiem, tym samym co API: `withCredentials`
 * sprawia, że handshake je dołącza. Nie przekazujemy żadnego tokenu w `auth`,
 * bo przeglądarka nie ma do niego dostępu i to jest zamierzone.
 */

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (socket !== null) return socket;

  socket = io({
    withCredentials: true,
    // Zaczynamy od odpytywania i pozwalamy podnieść do websocketa. Odwrotna
    // kolejność zerwałaby połączenie tam, gdzie proxy nie przepuszcza upgrade'u,
    // zamiast po cichu zadziałać wolniejszą drogą.
    transports: ['polling', 'websocket'],
    reconnection: true,
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
  });
  return socket;
}

/** Rozłączenie na wyjściu z aplikacji. Pokój sam posprząta po rozłączeniu gniazda. */
export function closeSocket(): void {
  socket?.disconnect();
  socket = null;
}
